import {GetAppType} from "api/getAppType";
import {useQuery} from "@tanstack/react-query";
import {queryKeys} from "../react-query/constant";

export const useAppType = () => {
    const fetchData = GetAppType();
    return useQuery(
        [queryKeys.appType],
        () => fetchData(), {
            staleTime: 5 * 60 * 1000,  // 5 min
            cacheTime: 6 * 60 * 1000
        }
    )
}